import ninegrid from "../index.js";

export class ngSorting
{
	#owner;
	#columns;
	
	constructor (owner) {
		this.#owner = owner;

		this.#init();
	}

	initialize = () => {

		this.#restore();
		this.#init();
	}
	
	#init = () => {
		this.#columns = [];
		
		$(".ng-table thead", this.#owner.body).off("click", "th,td", this.#onClick);
		$(".ng-table thead", this.#owner.body).on("click", "th,td", this.#onClick);
	};
	
	/**
	 * 정렬상태 초기화
	 */
	#restore = () => {
		this.#owner.data.sort((a,b) => { return a.__ng._[ninegrid.ROW.ORIGIN_ORDER] - b.__ng._[ninegrid.ROW.ORIGIN_ORDER]; });
	}
	
	#onClick = (e) => {

		if (e.target.tagName == "NG-CHECKBOX") return;
		
		e.target = e.target.closest("th,td");

		if (e.offsetX <= 2) return;
		if (e.offsetX >= e.target.offsetWidth - 2) return;
		if (e.target.closest("tr").sectionRowIndex + e.target.rowSpan != e.target.closest("thead").rows.length) return;

		switch (e.detail) {
			case 1:
				ninegrid.j.querySelectorAll(this.#owner).addClass("loading");
				
				setTimeout(() => {
					this.#sort(e);
					ninegrid.j.querySelectorAll(this.#owner).removeClass("loading");
				}); // should match OS multi-click speed
				break;
			case 2:
				console.log('double click action here');
				break;
			default:
				console.log('higher multi-click actions can be added as needed');
				break;
		}
	}
	
	#sort = (e) => {
		
		//if (e.offsetX <= 2) return;
		//if (e.offsetX >= e.target.offsetWidth - 2) return;
		
		var td = e.target.closest("th,td");
		var col = td.dataset.col;
		
		//if (td.closest("tr").sectionRowIndex + td.rowSpan != td.closest("thead").rows.length) return;
		
		var exprFunc;
		var colnm;
		$(this.#owner.template).find(`[data-col="${col}"]`).each((i,item) => {
			if (item.dataset.bind) {
				colnm = item.dataset.bind;
				if (item.dataset.expr) exprFunc = this.#owner.exprFunction(item.dataset.expr);
				return false;
			}
		});
		
		if (!colnm) return;

		if (!e.ctrlKey && !e.shiftKey) {
			//remove all class
			//$("thead th,thead td", this.#owner.body).not(`[data-col="${col}"]`).removeClass("asc").removeClass("desc");
			ninegrid.j.querySelectorAll(`thead th:not([data-col="${col}"],thead td:not([data-col="${col}"])`, this.#owner.body).removeClass("asc").removeClass("desc");
			
			this.#columns.splice(0, this.#columns.length);
		}
		
		ninegrid.removeIf(this.#columns, m => { return m.colnm == colnm; });
		
		if (!ninegrid.j.querySelectorAll(td).hasClass("asc") && !ninegrid.j.querySelectorAll(td).hasClass("desc")) {
			ninegrid.j.querySelectorAll(td).removeClass("desc").addClass("asc");
			
			this.#columns.push({"colnm": colnm, "asc": true, "expr-func": exprFunc, });
		}
		else if (ninegrid.j.querySelectorAll(td).hasClass("asc")) {
			ninegrid.j.querySelectorAll(td).removeClass("asc").addClass("desc");
			this.#columns.push({"colnm": colnm, "asc": false, "expr-func": exprFunc, });
		}
		else {
			ninegrid.j.querySelectorAll(td).removeClass("asc").removeClass("desc");
		}
		
		//console.log(ninegrid.j.querySelectorAll("thead th,thead td", this.#owner.body).hasClass("asc"), ninegrid.j.querySelectorAll("thead th,thead td", this.#owner.body).hasClass("desc"));
		
		if (!ninegrid.j.querySelectorAll("thead th,thead td", this.#owner.body).hasClass("asc") && !ninegrid.j.querySelectorAll("thead th,thead td", this.#owner.body).hasClass("desc")) {
			this.#restore();
		}
		else {
			this.#owner.data.sort((a,b) => { return this.#compareFn(a,b); });
		}

		(this.#owner.paging.type == ninegrid.PAGINGTYPE.CLIENT) ? this.#owner.paging.movePage(1) : this.#owner.view.redraw();
	}
	
	#compareFn = (a, b) => {
		
		for (var column of this.#columns) {

			if (column["expr-func"]) {

				const aa = this.#owner.data.conv(a);
				const bb = this.#owner.data.conv(b);
				
				if (column["expr-func"](aa,aa.__ng._[ninegrid.ROW.INDEX]) > column["expr-func"](bb,bb.__ng._[ninegrid.ROW.INDEX])) {
					return column.asc ? 1 : -1;
				}
				else if (column["expr-func"](aa,aa.__ng._[ninegrid.ROW.INDEX]) < column["expr-func"](bb,bb.__ng._[ninegrid.ROW.INDEX])) {
					return column.asc ? -1 : 1;
				}
			}
			else {
				const IDX = this.#owner.fields.indexOf(column.colnm);
				
				if (a.v[IDX] > b.v[IDX]) {
					return column.asc ? 1 : -1;
				}
				else if (a.v[IDX] < b.v[IDX]) {
					return column.asc ? -1 : 1;
				}
			}
		}
		
		return 0;
	};
}
